import { PayloadAction } from "@reduxjs/toolkit";
import { DueDateToolsContentItem, ToolAttributes } from "@/components/ToolsPage/api/interface";
import { ToolsState } from "@/components/ToolsPage/redux/types";

const ToolsReducer = {
  setToolsData: (state: ToolsState, action: PayloadAction<ToolAttributes>) => {
    state.toolData = action.payload;
  },
  setToolContentData: (state: ToolsState, action: PayloadAction<DueDateToolsContentItem[]>) => {
    state.content = action.payload;
  },
  setToolType: (state: ToolsState, action: PayloadAction<string>) => {
    state.type = action.payload;
  },
};

export default ToolsReducer;
